import React from 'react';
import { Form } from '@bd-uikit-web/React/Form';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import autobind from '@bd-uikit-web/js-helpers/autobind';
import { CardNumberElement, CardExpiryElement, CardCVCElement, injectStripe} from 'react-stripe-elements';
import FormHelper from '@bd-uikit-web/React/FormHelper';

class StripeForm extends React.Component {
  constructor() {
    super();
    const user = bdAuth.getUser();

    this.state = {
      user,
      cardData: null,
    };
    this.fh = new FormHelper((cardData) => this.setState({ cardData }));  
  }

  componentWillReceiveProps(nextProps) {
    const {card} = nextProps;
    if (card) {      
      this.fh.setStorage(card);
      this.setState({card});
    }
  }
  
  showNotiBanner(type, message) {
    rootDispatcher.dispatch('NB:OPEN', {
      type,
      msg: message,
    });
  }

  @autobind
  handleSubmit() {
    if (this.props.newCard) {
      const {name} = this.state.cardData;
      this.props.stripe.createToken({name}).then(({token}) => {
        const apiLink = `/users/${this.state.user.id}/cards`;
  
        bdReq.post(apiLink, token)
          .then(({ success, body }) => {      
            if (!success) {
              this.showNotiBanner('error', body.message);
              return;
            }
            this.props.newCard(body);
            this.showNotiBanner('success', 'Card added successfully');
          });
        return true;
      });
    }
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="card">
          <div className="col-12 col-ngl">
            <h4 className=" h--normalize-weight h--spacing-sm h--lower">Add Card</h4>
          </div>
          <section className="row">
            <div className="col-3 col-ngl col-sm-full">
              { this.fh.getInput(
                'Card holder',
                'name',
                'John Doe',
                { required: true, type: 'text' })
              }
            </div>
            <div className="col-3 col-ngl col-sm-full">
              <label class="form__desc-label">
                <strong>Creditcard Number</strong>
              </label>
              <CardNumberElement />
            </div>
            <div className="col-2 col-ngl col-sm-full ">
              <label class="form__desc-label">
                <strong>Valid Thru</strong>
              </label>
              
              <CardExpiryElement/>
            </div>
            <div className="col-1 col-ng col-sm-full ">
              <label class="form__desc-label">
                <strong>CVC</strong>
              </label>
              <CardCVCElement/>
            </div>
            <div className="col-3 col-ngr col-sm-full ">
              <strong style={{ opacity: 0 }}>-</strong>
              <button className="btn btn--block" type="submit"> Add Card</button>
            </div>
          </section>
        </div>
      </Form>
    );
  }
}

export default injectStripe(StripeForm);
